import { LayerNames, LayerVisibilityMode, StoredLayers } from '@/modules/common/types/layers';

import { useLayerStore } from '../store/useLayerStore';
import { ILayerService } from './ILayerService';

export class LayerServiceImpl implements ILayerService {
  private layerStore: typeof useLayerStore;

  public constructor(layerStore: typeof useLayerStore) {
    this.layerStore = layerStore;
  }

  setLayerVisibilityMode(layerName: LayerNames, mode: LayerVisibilityMode): void {
    this.layerStore.getState().setLayerVisibilityMode(layerName, mode);
  }

  loadLayerVisibilityModes(visibilityModes: Partial<Record<LayerNames, LayerVisibilityMode>>): void {
    this.layerStore.getState().loadLayerVisibilityModes(visibilityModes);
  }

  showAllElements(): void {
    this.layerStore.getState().showAllElements();
  }

  hideElements(idsToHide: string[]): void {
    this.layerStore.getState().hideElements(idsToHide);
  }

  showElements(idsToShow: string[]): void {
    this.layerStore.getState().showElements(idsToShow);
  }

  setLayerLock(layerName: LayerNames, lock: boolean): void {
    this.layerStore.getState().setLayerLock(layerName, lock);
  }

  lockElements(idsToLock: string[]): void {
    this.layerStore.getState().lockElements(idsToLock);
  }

  unlockElements(idsToUnlock: string[]): void {
    this.layerStore.getState().unlockElements(idsToUnlock);
  }

  loadLayersState(layers: StoredLayers): void {
    this.layerStore.getState().loadLayersState(layers);
  }
}
